import Cookie from "cookie-universal";

export const cookie = Cookie();
